export default "__VITE_ASSET__DBLvSHgy__"